import React from 'react';
import { Table } from "reactstrap";
import RedirectToLive from '../containers/RedirectToLive';

const SprintTournamentResults = (props) => {
  const {
    EventName,
    sprintTournamentList,
    ExecuteUpdate,
  } = props;

  const SprintTournament = () => {
    return (
      <div className="container">
        <h2>{EventName} Results </h2>
        <br />
        {content}
        <br />
        <br />
      </div>
    );
  }

  const content = sprintTournamentList.map((item, i) =>
    <div key={i}>
      {item.Riders.length > 0 && <div>
        <span><h4>{item.HeatName}</h4></span>
        <Table>
          <thead>
            <tr className="d-flex">
              <th className="col-md-2">Bib</th>
              <th className="col-md-5">Name</th>
              <th className="col-md-2">Nat</th>
              {(item.NumRaces === "1" || item.NumRaces === "2" || item.NumRaces === "3") && <th className={item.NumRaces === "1" ? "col-md-3 text-center" : item.NumRaces === "2" ? "col-md-2 text-center" : "col-md-1 text-center"}>Race 1</th>}
              {(item.NumRaces === "2" || item.NumRaces === "3") && <th className="col-md-1 text-center">Race 2</th>}
              {item.NumRaces === "3" && <th className="col-md-1 text-center">Decider</th>}
            </tr>
          </thead>
          <tbody>
            {item.Riders.map((row, ii) =>
              <tr className="d-flex" key={ii}>
                <td className="col-md-2">{row.Bib}</td>
                <td className="col-md-5">{row.Name}</td>
                <td className="col-md-2">
                  {row.Nat && <img
                    src={process.env.PUBLIC_URL + '/Flags/' + row.Nat + '.bmp'}
                    height="25"
                    width="60"
                    alt={row.Nat}
                  />}
                </td>
                {(item.NumRaces === "1" || item.NumRaces === "2" || item.NumRaces === "3") && <td className={item.NumRaces === "1" ? "col-md-3 text-center" : item.NumRaces === "2" ? "col-md-2 text-center" : "col-md-1 text-center"}>{row.RankH1 === 1 ? "X" : ""}</td>}
                {(item.NumRaces === "2" || item.NumRaces === "3") && <td className="col-md-1 text-center">{row.RankH2 === 1 ? "X" : ""}</td>}
                {item.NumRaces === "3" && <td className="col-md-1 text-center">{row.RankH3 === 1 ? "X" : ""}</td>}
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      }
    </div>
  );


  return (
    <div>
      <RedirectToLive Update={ExecuteUpdate} />
      <SprintTournament />
    </div>

  );
}

export default SprintTournamentResults;